<template>
    <div class="alert-wrapper">
        <Alert v-for="(alert, $index) in alerts" :key="$index" :alert-idx="$index" :alert-msg="alert.msg" :alert-class="alert.class" :dismiss-timeout="alert.timeout" />
    </div>
</template>

<script>
    import useAlerts from '../../shared/composables/useAlerts';
    import Alert from '../../shared/components/Alert.vue'

    export default {
        name: 'Alerts',
        components: {
            Alert
        },
		setup () {
            const { alerts } = useAlerts();

            return {
                alerts
            }
		}
    };
</script>
